import React, { useEffect, useState } from 'react'
import MotionHoc from '../../../utils/MotionHoc';
import { Col, Row, Space, Table, Card, Spin, Select, message, Button, Tag, Calendar, Badge, Segmented, Divider, Flex, Radio } from "antd";
import Search from "antd/es/input/Search";
import { ArrowLeftOutlined, CheckOutlined, MailOutlined, SearchOutlined, SendOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import ThaiDatePicker from '../../../hook/ThaiDatePickerNew';
import CheckThaiPost from './modal/CheckThaiPost';
import AddLetter from './modal/AddLetter';
import { colorStatusDG, getStatusColor, getTypeReplyName, handleShowTYPE } from './hook/function';
import ConfirmLetter from './modal/ConfirmLetter';
import { baseUrlAREA, HEADERS_BASIC, LOAD_MAIN_LETTER } from '../../API/apiUrlsGarfe';
import CheckCONTNO from './modal/CheckCONTNO';

function CheckStatusPostDG() {
  // const userCompany = localStorage.getItem("COMPANY_ID");
  // const TESTcontractOptions = [
  //   { value: "lsfhp", label: "สัญญา 1" },
  //   { value: "vsfhp", label: "สัญญา 2" },
  //   { value: "psfhp", label: "สัญญา 3" },
  //   { value: "rpsl", label: "สัญญา 3(ใหม่)" },
  //   { value: "sfhp", label: "สัญญา 8" }
  // ];

  const [loading, setLoading] = useState(false);
  // const [arrData, setArrData] = useState([]);
  // const [arrayTable, setArrayTable] = useState([]);
  // const [datePicker, setDatePicker] = useState();
  // const [selectedContract, setSelectedContract] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowDatas, setSelectedRowDatas] = useState([]);
  const [isModalCheckThaiPost, setIsModalCheckThaiPost] = useState(false);
  const [isModalConfirmLetter, setIsModalConfirmLetter] = useState(false);

  // --- States ปฏิทิน ---
  const [calendarMode, setCalendarMode] = useState("month");
  const [calendarValue, setCalendarValue] = useState(dayjs());
  const [calendarPoint, setCalendarPoint] = useState([]);

  const [masterData, setMasterData] = useState([]);


  // --- States สำหรับสลับหน้า ---
  const [isDetailView, setIsDetailView] = useState(false); // false = Calendar, true = AddBarcode2
  const [selectedDate, setSelectedDate] = useState(null);

  const [dayDataMaster, setDayDataMaster] = useState([]); // ข้อมูลที่จะส่งให้ AddBarcode2
  const [dayData, setDayData] = useState([]); // ข้อมูลที่จะส่งให้ AddBarcode2

  // --- States สถานะ ---
  const [dataStatus, setDataStatus] = useState([]);
  // const [dataStatusHead, setDataStatusHead] = useState([]);

  const [isModalAddLetter, setIsModalAddLetter] = useState(false);
  const [dataSearch, setDataSearch] = useState();
  const [isModalSearch, setIsModalSearch] = useState(false);



  // const handleLoad = () => {
  // if (selectedContract?.value && datePicker) {
  // loadData();
  // } else {
  //   message.error("กรุณาเลือกสัญญาและวันที่ !! ");
  // }
  // };

  useEffect(() => {
    if (calendarPoint.length === 0) {
      loadData(dayjs())
    }
  }, [])


  const loadData = (e) => {
    setLoading(true);

    const payload = {
      date: e,
      // date: datePicker.format("YYYY-MM-DD"),
      // type: selectedContract.value,
      // company: userCompany
    };

    axios.post(baseUrlAREA + LOAD_MAIN_LETTER, payload, { headers: HEADERS_BASIC })
      .then((response) => {

        if (response.status === 200) {
          // console.log("res data", response.data);
          setMasterData(response.data.data)
          setCalendarPoint(response.data.data);
          setDataStatus(response.data.summary)
          // setDataStatusHead(response.data.summarieHead)
          // // setSelectedRowKeys([]);
          // // setSelectedRowDatas([]);
          // setArrayTable(response.data)
          // setArrData(response.data);
        }
      })
      .catch((error) => {
        // 2. จัดการกับข้อผิดพลาด (Error)
        const status = error?.response?.status;
        const serverMsg = error?.response?.data?.message;
        console.error("API error:", status, serverMsg || error.message);
        setCalendarPoint([])
        setDataStatus([])
        // setDataStatusHead([])
        // setArrayTable([]);
        // setArrData([]);
        message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Helper: กรองข้อมูลของวันนั้นๆ
  const getListData = (value) => {
    if (!calendarPoint || calendarPoint?.length === 0) return [];
    return calendarPoint?.filter((item) => dayjs(item.dateReply).isSame(value, 'day'));
  };

  // เมื่อจิ้มวันที่
  const handleSelectDate = (value) => {
    if (calendarMode === 'year') {
      setCalendarValue(value);
      return;
    }
    setCalendarValue(value);

    // 1. ดึง mainData เฉพาะวันที่เลือก (Logic เดิม)
    const mainList = getListData(value);

    // 2. ✅ ดึง closeData (เอาไปทั้งหมด หรือจะกรองก็ได้ แต่นี่คือเอาไปทั้งหมดจาก API)
    // const closeList = calendarPoint?.closeData || [];

    // เซ็ตข้อมูลและเปลี่ยนหน้า
    setSelectedDate(value);
    setDayDataMaster(mainList);     // ส่ง MainData
    setDayData(mainList);     // ส่ง MainData
    // setDayCloseData(closeList); // ✅ ส่ง CloseData
    setIsDetailView(true);
  };

  const handleBackToCalendar = () => {
    setIsDetailView(false);
    setDayData([]);

    setSelectedRowKeys([]);
    setSelectedRowDatas([]);
    // setDayCloseData(null); // ✅ เคลียร์ค่า
  };

  // const dateCellRender = (value) => {
  //   const listData = getListData(value);
  //   if (listData.length === 0) return null;
  //   listData.map((e) => {
  //     return (
  //       <div style={{ textAlign: 'center' }}>
  //         {/* <div style={{ marginBottom: 4 }}><Badge count={<FileSearchOutlined style={{ color: "#1890ff" }} />} /></div> */}
  //         <b><Tag>{e.typeReply}</Tag></b>
  //         <b><Badge color="green" text={`รายการ (${listData.length})`} style={{ fontSize: '12px' }} /></b>
  //       </div>
  //     );
  //   })
  // };

  const dateCellRender = (value) => {
    const listData = getListData(value);

    if (!listData || listData.length === 0) return null;

    // นับจำนวนแยกตามประเภทก่อน
    const countType1 = listData.filter(e => e.typeReply === 1).length;  //บอกกล่าว
    const countType2 = listData.filter(e => e.typeReply === 2).length;  //สิทธิซื้อรถคืน
    const countType3 = listData.filter(e => e.typeReply === 3).length;  //แจ้งราคาขายรถ
    const countType4 = listData.filter(e => e.typeReply === 4).length;  //บอกเลิก

    const countType5 = listData.filter(e => e.typeReply === 5).length;  //บอกเลิก(มือ)
    const countType6 = listData.filter(e => e.typeReply === 6).length;  //สิทธิซื้อรถคืน(พี่นิ๊กกี้)
    // const countType4 = listData.filter(e => e.typeReply === 4).length;  //บอกเลิก

    return (
      <div style={{ textAlign: 'center', minHeight: '100%', height: '100%' }}>
        {/* <div style={{ textAlign: 'center', padding: '5px 0' }}> */}
        <div >
          <b>
            <Badge
              color="green"
              text={`${listData.length} รายการ`}
              style={{ fontSize: '12px' }}
            />
          </b>
          {countType1 > 0 && (
            <div style={{ marginBottom: 2 }}>
              <Tag color="cyan">บอกกล่าว ({countType1})</Tag>
            </div>
          )}
          {countType2 > 0 && (
            <div style={{ marginBottom: 2 }}>
              <Tag color="purple">สิทธิซื้อรถคืน ({countType2})</Tag>
            </div>
          )}
          {countType3 > 0 && (
            <div style={{ marginBottom: 2 }}>
              <Tag color="orange">แจ้งราคาขายรถ ({countType3})</Tag>
            </div>
          )}
          {countType4 > 0 && (
            <div style={{ marginBottom: 2 }}>
              <Tag color="magenta">บอกเลิก ({countType4})</Tag>
            </div>
          )}
          {countType5 > 0 && (
            <div style={{ marginBottom: 2 }}>
              <Tag color="magenta">บอกเลิก(มือ) ({countType5})</Tag>
            </div>
          )}
          {countType6 > 0 && (
            <div style={{ marginBottom: 2 }}>
              <Tag color="magenta">สิทธิซื้อรถคืน(พี่นิ๊กกี้) ({countType6})</Tag>
            </div>
          )}
        </div>

      </div>
    );
  };

  // const monthCellRender = (value) => {
  //   const count = calendarPoint?.filter(item => {
  //     const d = dayjs(item.dateReply);
  //     return d.year() === value.year() && d.month() === value.month();
  //   }).length || 0;
  //   return count > 0 ? <div style={{ textAlign: "center", paddingTop: 8 }}><Badge count={count} style={{ backgroundColor: "#52c41a" }} overflowCount={999} /></div> : null;
  // };

  // const onSearch = (value) => {
  //   setLoading(true);
  //   let result;
  //   if (value) {
  //     result = dayDataMaster.filter(
  //       (item) =>
  //         (item.CONTNO && item.CONTNO.includes(value.trim())) ||
  //         (item.customerFullName && item.customerFullName.includes(value.trim()))
  //     );
  //   } else {
  //     result = dayDataMaster;
  //   }
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 250);
  //   setDayData(result);
  // };

  const onSearch = (value) => {
    // console.log("value", value)
    setDataSearch(value)
    setIsModalSearch(true)
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "key",
      align: "center",
      render: (_, record) => (
        <>{record.key}</>
      ),
    },
    {
      title: "รายละเอียดลูกค้า",
      dataIndex: "customerFullName",
      key: "customerFullName",
      align: "center",
      render: (_, record) =>
        <>
          {/* {record.customerFullName} */}
          <div>
            {record?.customerFullName}
          </div>
          <div>
            {record?.typeReply === 1 ? `(คนค้ำ${record?.customerTypeId})` :
              record?.typeReply === 2 && record?.customerTypeId === 0 ? "(ผู้เช่าซื้อ)" :
                record?.typeReply === 2 && record?.customerTypeId !== 0 ? `(คนค้ำ${record?.customerTypeId})` :
                  record?.typeReply === 3 && record?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                    record?.typeReply === 3 && record?.customerTypeId !== 0 ? `(คนค้ำ${record?.customerTypeId})` :
                      record?.typeReply === 4 && record?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                        record?.typeReply === 4 && record?.customerTypeId !== 0 ? `(คนค้ำ${record?.customerTypeId})` :
                          "-"} ({record?.CONTNO})
          </div>
        </>,
    },
    {
      title: "ems จดหมาย",
      dataIndex: "parcelNo",
      key: "parcelNo",
      align: "center",
    },
    {
      title: "ems ใบตอบกลับ",
      dataIndex: "parcelNoResponse",
      key: "parcelNoResponse",
      align: "center",
    },
    {
      title: "รายละเอียด",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (_, record) =>
        <div style={{ textAlign: "left" }}>
          <div>ประเภทจดหมาย: <Tag color={getStatusColor(record.status1)}>{record.status1 !== "" ? record.status1 : "-"}</Tag></div>
          <div>จัดส่ง: <Tag color={getStatusColor(record.status2)}>{record.status2 !== "" ? record.status2 : "-"}</Tag></div>
          <div>คอนเฟิร์ม: <Tag color={getStatusColor(record.status3)}>{record.status3 !== "" ? record.status3 : "-"}</Tag></div>
          <div>ตอบกลับ: <Tag color={getStatusColor(record.status4)}>{record.status4 !== "" ? record.status4 : "-"}</Tag></div>
        </div>,
    },
    // {
    //   title: "Note",
    //   dataIndex: "",
    //   key: "",
    //   align: "center",
    //   render: (_, record) =>
    //     <div style={{ textAlign: "center" }}>
    //       -
    //     </div>,
    // },
    // {
    //   title: "Action",
    //   dataIndex: "",
    //   key: "",
    //   align: "center",
    //   render: (_, record) =>
    //     <div style={{ textAlign: "center" }}>
    //       <Button
    //         type='primary'
    //       >Note</Button>
    //     </div>,
    // },
  ];


  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    // อัปเดต state เพื่อให้ checkbox แสดงสถานะถูกเลือก
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRowDatas(selectedRows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    // fixed: true, // ถ้าต้องการ fix checkbox ไว้ซ้ายสุดเวลามี scroll
  };

  const onCheckThaiPost = () => {
    if (selectedRowDatas?.length > 0) {
      setIsModalCheckThaiPost(true)
    }
  };

  const onConfirmLetter = () => {
    if (dayData?.length > 0) {
      setIsModalConfirmLetter(true)
    }
  };

  const handleOpenModalAddLetter = () => {
    setIsModalAddLetter(true)
  }

  const handleChangeDate = (e) => {
    setCalendarValue(e)
    loadData(e)
  }

  const handleFilterStatus = (value) => {
    if (value === "ทั้งหมด") {
      setCalendarPoint(masterData)
      return;
    }

    const filterData = masterData.filter((item) => {
      // เช็คว่า value นี้อยู่ในกลุ่มไหน แล้วเทียบให้ถูก field

      // กลุ่ม 1
      if (["บอกกล่าว", "สิทธิซื้อรถคืน", "แจ้งราคาขายรถ", "บอกเลิก"].includes(value)) {
        return item?.status1 === value;
      }
      // กลุ่ม 2
      if (["อยู่ระหว่างการนำจ่าย", "นำจ่ายไม่สำเร็จ", "นำจ่ายสำเร็จ"].includes(value)) {
        return item?.status2 === value;
      }
      // กลุ่ม 3
      if (["รอคอนเฟิร์ม", "คอนเฟิร์มแล้ว"].includes(value)) {
        return item?.status3 === value;
      }
      // กลุ่ม 4
      if (["ตอบกลับ", "ตีกลับ"].includes(value)) {
        return item?.status4 === value;
      }

      return [];
    });
    setCalendarPoint(filterData);
  }

  return (
    <>
      <Spin spinning={loading} size="large" tip=" Loading... ">
        <Card>
          <Row>
            <Col span={"24"}>

              {!isDetailView ?
                <Calendar
                  value={calendarValue}
                  mode={calendarMode}
                  onSelect={handleSelectDate}
                  onPanelChange={(v, m) => { setCalendarValue(v); setCalendarMode(m); }}
                  cellRender={(current, info) => {
                    if (info.type === 'date') return dateCellRender(current);
                    // if (info.type === 'month') return monthCellRender(current);
                    return info.originNode;
                  }}
                  headerRender={({ value, type, onChange, onTypeChange }) => {
                    // console.log("value", value)
                    const cur = value.clone();
                    const years = Array.from({ length: 11 }, (_, i) => dayjs().year() - 5 + i);
                    const months = Array.from({ length: 12 }, (_, i) => ({ value: i, label: dayjs().month(i).format("MMMM") }));
                    return (
                      // <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", padding: 8 }}>
                      <div style={{ minHeight: '120px', height: '100%' }}>
                        {/* <> */}
                        <Card>
                          <Row>
                            <Col span={12} style={{ textAlign: 'start' }}>
                              <Select
                                value={cur.month()}
                                options={months}
                                onChange={(m) => handleChangeDate(cur.month(m))}
                                style={{ width: '200px' }}
                                size='large'
                              // disabled={type === "year"}
                              />
                              <Select
                                value={cur.year()}
                                options={years.map((y) => ({ value: y, label: y }))}
                                onChange={(y) => handleChangeDate(cur.year(y))}
                                style={{ width: '200px' }}
                                size='large'
                              />
                              {/* <Select value={cur.year()} options={years.map((y) => ({ value: y, label: y }))} onChange={(y) => setCalendarValue(cur.year(y))} /> */}
                              {/* <Select value={cur.month()} options={months} onChange={(m) => setCalendarValue(cur.month(m))} disabled={type === "year"} /> */}
                              {/* <Segmented size="small" value={type === "year" ? "Year" : "Month"} options={["Month", "Year"]} onChange={(v) => onTypeChange(v === "Year" ? "year" : "month")} /> */}
                            </Col>
                            <Col span={12} style={{ textAlign: 'end' }}>
                              <Search
                                placeholder="ค้นหาสัญญา"
                                enterButton
                                onSearch={onSearch}
                                style={{
                                  width: "auto",
                                  borderRadius: "8px",
                                }}
                                size="large"
                              />
                            </Col>
                            <Col span={24} style={{ textAlign: 'end', marginTop: 5 }}>
                              <Button
                                type='primary'
                                icon={<MailOutlined />}
                                style={{ backgroundColor: 'orange' }}
                                onClick={handleOpenModalAddLetter}
                              >
                                เพิ่มจดหมาย
                              </Button>
                            </Col>
                          </Row>
                          <Col span={24} style={{ textAlign: 'start', marginTop: 5 }}>
                            <Space wrap size={[12, 12]}>
                              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                {dataStatus.map((item, index) => (
                                  <Tag
                                    key={index}
                                    color={getStatusColor(item.status)}
                                    style={{ cursor: 'pointer', padding: '5px 12px', width: "auto" }}
                                    onClick={() => {
                                      // console.log("Selected Status:", item.status);
                                      handleFilterStatus(item.status)
                                      // setFilterStatus(item.status); // ใส่ logic filter ของคุณที่นี่
                                    }}
                                  >
                                    <span style={{ fontWeight: 'bold' }}>
                                      {item.nameStatus}
                                      <span style={{ marginLeft: '8px', opacity: 0.8 }}>
                                        ({item.totalCount})
                                      </span>
                                    </span>
                                  </Tag>
                                ))}
                              </div>
                            </Space>
                          </Col>
                        </Card>
                        <Divider />
                        {/* </Col> */}
                      </div>

                    );
                  }}
                />
                :
                <>
                  <Card>
                    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                      <Col span={24} style={{ textAlign: 'start' }}>
                        <Button icon={<ArrowLeftOutlined />} onClick={handleBackToCalendar} style={{ marginRight: 16 }}>
                          กลับปฏิทิน
                        </Button>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                          วันที่: {dayjs(selectedDate).format('DD/MM/YYYY')}
                        </span>
                      </Col>
                      <Divider />
                      <Col span={12} style={{ textAlign: "start", marginTop: "5px" }}>
                        <Space>
                          <Button type='primary' danger icon={<SendOutlined />} disabled={selectedRowKeys?.length === 0} onClick={onCheckThaiPost}>ตรวจสอบไปรษณีย์</Button>
                          <Button type='primary' style={{ backgroundColor: 'green' }} icon={<CheckOutlined />} disabled={dayData?.length === 0} onClick={onConfirmLetter}>คอนเฟิร์ม</Button>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "end", marginTop: "5px" }}>
                        <Search
                          placeholder="ค้นหาสัญญา"
                          enterButton
                          onSearch={onSearch}
                          style={{
                            width: "auto",
                            borderRadius: "8px",
                          }}
                          size="large"
                        />
                      </Col>

                    </Row>
                    <Table
                      rowSelection={rowSelection}
                      style={{ marginTop: "10px" }}
                      size="small"
                      columns={columns}
                      dataSource={dayData}
                      scroll={{ x: 850 }}
                      footer={() => (
                        <p>จำนวนสัญญาที่ค้นหาทั้งหมด {dayData?.length} </p>
                      )}
                    />
                  </Card>
                </>
              }
            </Col>
          </Row>
          {isModalCheckThaiPost ?
            <CheckThaiPost
              open={isModalCheckThaiPost}
              close={setIsModalCheckThaiPost}
              data={selectedRowDatas}
              loadData={loadData}
            />
            : null}
          {isModalAddLetter ?
            <AddLetter
              open={isModalAddLetter}
              close={setIsModalAddLetter}
              loadData={loadData}
            />
            : null}
          {isModalConfirmLetter ?
            <ConfirmLetter
              open={isModalConfirmLetter}
              close={setIsModalConfirmLetter}
              data={dayData}
              setDayData={setDayData}
              loadData={loadData}
            />
            : null}
          {isModalSearch ?
            <CheckCONTNO
              open={isModalSearch}
              close={setIsModalSearch}
              data={dataSearch}
            />
            : null}
        </Card >
      </Spin >
    </>
  )
}

const CheckStatusPostDGs = MotionHoc(CheckStatusPostDG);
export default CheckStatusPostDGs;
